(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sma-testimonial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_QUERY = '(max-width: 749px)';
    var AUTOPLAY_DELAY = 5000;

    function initSection(section) {
      if (!section || section.dataset.smaInit === '1') return;
      section.dataset.smaInit = '1';

      var track = section.querySelector('[data-sma-testimonial-track]');
      var dotsWrap = section.querySelector('[data-sma-testimonial-dots]');
      if (!track || !dotsWrap) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.sma-testimonial-box'));
      if (!slides.length) return;

      var mq = window.matchMedia(MOBILE_QUERY);
      var timer = null;
      var current = 0;

      function buildDots() {
        dotsWrap.innerHTML = '';
        slides.forEach(function (slide, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sma-testimonial-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
          dot.addEventListener('click', function () {
            goTo(i, true);
          });
          dotsWrap.appendChild(dot);
        });
      }

      function setActive(i) {
        current = i;
        var dots = dotsWrap.querySelectorAll('.sma-testimonial-dot');
        for (var d = 0; d < dots.length; d++) {
          if (d === i) {
            dots[d].classList.add('is-active');
          } else {
            dots[d].classList.remove('is-active');
          }
        }
      }

      function goTo(i, userInitiated) {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        var slide = slides[i];
        var left = slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
        track.scrollTo({ left: left, behavior: 'smooth' });
        setActive(i);
        if (userInitiated) restartAutoplay();
      }

      function next() {
        goTo(current + 1, false);
      }

      function startAutoplay() {
        if (timer || !mq.matches || slides.length < 2) return;
        timer = setInterval(next, AUTOPLAY_DELAY);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function restartAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      /* Keep active dot synced when the user scrolls manually */
      var scrollDebounce;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(function () {
          var center = track.scrollLeft + track.clientWidth / 2;
          var closest = 0;
          var minDist = Infinity;
          slides.forEach(function (s, i) {
            var sc = s.offsetLeft + s.clientWidth / 2;
            var dist = Math.abs(sc - center);
            if (dist < minDist) {
              minDist = dist;
              closest = i;
            }
          });
          setActive(closest);
        }, 80);
      }, { passive: true });

      /* Autoplay only starts once the carousel reaches the viewport */
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        });
      }, { threshold: 0.3 });

      /* Pause on user interaction, resume after */
      track.addEventListener('pointerdown', stopAutoplay);
      track.addEventListener('pointerup', restartAutoplay);

      mq.addEventListener('change', function () {
        stopAutoplay();
        setActive(0);
        track.scrollTo({ left: 0, behavior: 'auto' });
        startAutoplay();
      });

      buildDots();
      observer.observe(section);
    }

    function initAll() {
      var sections = document.querySelectorAll('[data-sma-testimonial]');
      for (var i = 0; i < sections.length; i++) {
        initSection(sections[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Theme editor support */
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-sma-testimonial]');
      if (s) {
        s.dataset.smaInit = '';
        initSection(s);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
